// src/layout/Maincontent.jsx
import React from "react";
import { Box, Toolbar, useMediaQuery } from "@mui/material";
import colors from "../constants/colors";

const MainContent = ({ children, sidebarOpen }) => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const drawerWidth = isMobile ? 0 : sidebarOpen ? 250 : 80;

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        width: isMobile ? "100%" : `calc(100% - ${drawerWidth}px)`,
        transition: "all 0.3s ease",
        backgroundColor: colors.darkWhite,

        // ✅ Scrollbar should start below navbar
        height: "calc(100vh - 70px)",
        overflowY: "auto",
        mt: "70px", // ✅ Push content below the fixed navbar

        // "&::-webkit-scrollbar": {
        //   width: "6px",
        //   height: "6px",
        // },
        // "&::-webkit-scrollbar-thumb": {
        //   backgroundColor: "#888",
        //   borderRadius: "6px",
        // },
      }}
    >
      {/* optional Toolbar can be removed since we use margin-top */}
      {/* <Toolbar /> */}
      {children}
    </Box>
  );
};

export default MainContent;
